import { useEffect } from "react"

import { applyRateToAmounts, hasMissingAmountsInCurrency } from "../lib"

export const useFillMissingAmountsInCurrency = ({ values, setValues }) => {
  const exchangeRate = values.exchange_rate
  const missingAmounts = hasMissingAmountsInCurrency(values.ae_online_products)

  useEffect(() => {
    if (!exchangeRate || !missingAmounts) {
      return
    }
    setValues((current) => ({
      ...current,
      ae_online_products: applyRateToAmounts(
        current.ae_online_products,
        current.exchange_rate
      )
    }))
  }, [exchangeRate, missingAmounts, setValues])
}
